export default __webpack_public_path__ + "static/media/The Kruks Photography-1453.43e66c52.jpg";